import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://3607dbae893361b5e1388105b988f016@o4509790822662144.ingest.de.sentry.io/4509790824955984',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  sendDefaultPii: true,
  tracesSampleRate: 0.2, // Для production используйте меньшее значение (например, 0.1)
  replaysSessionSampleRate: 0.1, // 10% сессий будут записаны
  replaysOnErrorSampleRate: 1.0, // 100% сессий с ошибками будут записаны
})
